import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { convertHelpers, getGoogleSheetDataValues } from '../../../../global/common/convert';
import { _sdm } from '../../elements/dashboard/SportsDashboard';
import { _sportsFormProps } from '../contexts/SportsSeasonContext';
import { _districtCollections } from './SportsDistrictReducer';

export const _sportCollections_pks = {
  districtContacts: 'districtContacts',
  gls_scores: 'gls_scores',
  gls_teams: 'gls_teams',
  news: 'news',
  schoolContacts: 'schoolContacts',
  sportsAccess_district: 'sportsAccess_district',
  sportsAccess_schools: 'sportsAccess_schools',
  sportsAccess_teams: 'sportsAccess_teams',
  sportsAccess_sports: 'sportsAccess_sports',
  sportsSettings_rosters: 'sportsSettings_rosters',
  teamRosters: 'teamRosters_seasonal',
  tournaments: 'tournaments',
}

export const _sportCollections = {
  _history: '_history',
  _matches_seasonal: '_matches_seasonal',
  _playoffs: '_playoffs',
  _rankings: '_rankings_seasonal',
  _rosters: '_rosters',
  _schools: '_schools',
  _scores_seasonal: '_scores_seasonal',
  _seasonals: '_seasonals',
  _sportsAccess_sports: '_sportsAccess_sports',
  _teams: '_teams',
  _teams_seasonal: '_teams_seasonal',
  _tournaments: '_tournaments',
}

export const sportAccessTypes = {
  none: 'none',
  team: 'team',
  sport: 'sport',
  school: 'school',
  tournament: 'tournament',
  accessLink: 'accessLink',
  scoreLink: 'scoreLink',
  googleLink: 'googleLink',
  tournamentResults: 'tournamentResults',
  teamRoster: 'teamRoster',
}

const _accessOptions = {
  schools: {
    edit: 'edit',
    full: 'full',
    scores: 'scores',
  },
  sport: {
    edit: 'edit',
    full: 'full',
    scores: 'scores',
  },
  team: {
    edit: 'edit',
    full: 'full',
    scores: 'scores',
  }
}

const rts = {
  handleConfirm_save: 'handleConfirm_save',
  handleConfirm_teamSettings: 'handleConfirm_teamSettings',
  handleCreate_gsTeamSheetsWithProtection: 'handleCreate_gsTeamSheetsWithProtection',
  handleGet_gsSheetData: 'handleGet_gsSheetData',
  handleGet_gsSheetDatas: 'handleGet_gsSheetDatas',
  handleGet_gsTabValues: 'handleGet_gsTabValues',
  handleInit_sportsSidebar: 'handleInit_sportsSidebar',
  // handleSave_sportsDataToDatabase: 'handleSave_sportsDataToDatabase',
  // handleSave_glsToDatabase: 'handleSave_glsToDatabase',
  // handleSave_teamSettings: 'handleSave_teamSettings',
  handleSet_currentMenuKey: 'handleSet_currentMenuKey',
  handleSet_formData: 'handleSet_formData',
  handleSet_gsSheetData: 'handleSet_gsSheetData',
  handleSet_gsSheetDatas: 'handleSet_gsSheetDatas',
  handleSet_gsTabValues: 'handleSet_gsTabValues',
  handleShow_createNew: 'handleShow_createNew',
  handleUpdate_gsDistrictAccess: 'handleUpdate_gsDistrictAccess',
  ...grts
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const sportsSidebarReducer = (state, action) => {

  const {
    current_accessOrGls,
    currentMenuKey,
    fn_cls,
    latestSeason,
    menuItems,
    sportPermissions,
    sportsDataMode,
    teams,
    tournamentResults,
  } = state
  const { type, dispatch } = action

  const { handleConfirm_save, handleConfirm_teamSettings, handleSet_gsSheetData, handleSet_gsSheetDatas, handleSet_gsTabValues } = sportsSidebarHandlers(dispatch)


  console.log('action', action)

  switch (type) {

    case rts.handleInit_sportsSidebar:
      const _initState = getInitState(action, state)
      const _formProps = getSportsFormProps(_initState)
      return {
        ...state,
        ..._initState,
        access_teams: action.access_teams,
        access_sports: action.access_sports,
        access_schools: action.access_schools,
        sportAccessType: action.sportAccessType,
        sportsDataMode: action.sportsDataMode,
        formProps: _formProps,
        currentItem: null,
        currentMenuKey: null,
        showCreateNew: false,
        formData: null
      }

    case rts.handleSet_currentMenuKey:
      const _formData = getFormData(action.currentMenuKey, state)
      const _currentItem = menuItems[action.currentMenuKey]
      return {
        ...state,
        formData: _formData,
        currentItem: _currentItem,
        currentMenuKey: action.currentMenuKey
      }

    case rts.handleSet_formData:

      const _fd = action.formData
      const { teamAccess } = _fd
      const _current_accessOrGls = current_accessOrGls ? { ...current_accessOrGls } : {}

      switch (sportsDataMode) {

        case _sdm.district.accessSchools:
        case _sdm.district.accessSports:
        case _sdm.sports.accessTeams:
          _current_accessOrGls[currentMenuKey] = teamAccess
          return { ...state, formData: teamAccess, current_accessOrGls: _current_accessOrGls, menuObjects: _current_accessOrGls }

        case _sdm.district.glsScores:
        case _sdm.sports.news:
          _current_accessOrGls[currentMenuKey] = _fd
          return { ...state, formData: _fd, current_accessOrGls: _current_accessOrGls, menuObjects: _current_accessOrGls }

        case _sdm.sports.tournamentResults:
          const _tournamentResults = { ...tournamentResults }
          _current_accessOrGls[currentMenuKey] = _fd
          _tournamentResults[currentMenuKey] = _fd
          return { ...state, tournamentResults: _tournamentResults, formData: _fd, current_accessOrGls: _current_accessOrGls, menuObjects: _current_accessOrGls }

        default:
        // nothing 

      }
      return { ...state, formData: _fd }

    case rts.handleConfirm_teamSettings:
      return { ...state, updating: null }


    case rts.handleConfirm_save:
      return { ...state, updating: null }

    case rts.handleShow_createNew:
      const _formPropz = getSportsFormProps(state)
      const _formDataa = getFormData(action.currentMenuKey, state)
      const _menuItems = { ...menuItems }
      _menuItems['newItem'] = { name: 'newItem', _itemKey: 'newItem' }
      return { ...state, showCreateNew: !state.showCreateNew, formProps: _formPropz, formData: _formDataa, menuItems: _menuItems }

    case rts.handleGet_gsTabValues:
      getGsTabValues(fn_cls, action.settings, action.sheetType, sportsDataMode, action.latestSeason, handleSet_gsTabValues)
      return { ...state }

    case rts.handleSet_gsTabValues:
      return { ...state, [action.sheetName]: action.results, sheetType: action.sheetType, updating: null }

    case rts.handleGet_gsSheetData:
      getGsSheetData(fn_cls, action, handleSet_gsSheetData)
      return { ...state }

    case rts.handleGet_gsSheetDatas:
      getGsSheetsData(fn_cls, action, handleSet_gsSheetDatas)
      return { ...state }

    case rts.handleSet_gsSheetData:
      const _sheetsData = state.sheetsData ? { ...state.sheetsData } : {}
      _sheetsData[action.sheetName] = action.results
      return { ...state, sheetsData: _sheetsData, updating: null, current_accessOrGls: action.results }

    case rts.handleSet_gsSheetDatas:
      const { data } = action
      const { success, result } = data
      const _teamRosters = {}
      if (success) {
        _.forEach(result, (item, rosterName) => {
          const team = _.find(teams, { name: _.startCase(rosterName) })
          if (team) {
            const { dataItems } = item
            if (!_.isEmpty(dataItems)) {
              _teamRosters[rosterName] = {}
              const propValues = {}
              _.forEach(dataItems, (di, diKey) => {
                const { graduationYear } = di
                if (graduationYear >= latestSeason) {
                  propValues[diKey] = di
                  delete propValues[diKey]._itemKey
                }
              })
              _teamRosters[rosterName] = {
                ...propValues,
              }
            }
          } else {
            // console.log('s', _.startCase(rosterName))
          }
        })
      }
      return { ...state, updating: null, teamRosters: _teamRosters }
    // return { ...state, sheetsData: _sheetsData, updating: null, current_accessOrGls: action.results }

    case rts.handleCreate_gsTeamSheetsWithProtection:
      createGsTeamSheetsWithProtections(fn_cls, action)
      return { ...state }

    case rts.handleUpdate_gsDistrictAccess:
      updateGsDistrictAccess(fn_cls, action, state)
      return { ...state }

    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation }, { gsMatchedRefreshed: false })

    default:
      return { ...state }
  }
}

export const sportsSidebarHandlers = (dispatch) => {
  return {
    handleConfirm_save: () => { dispatch({ type: rts.handleConfirm_save, dispatch }) },
    handleConfirm_teamSettings: () => { dispatch({ type: rts.handleConfirm_teamSettings, dispatch }) },
    handleCreate_gsTeamSheetsWithProtection: (access_teams, teams) => { dispatch({ type: rts.handleCreate_gsTeamSheetsWithProtection, dispatch, access_teams, teams }) },
    handleGet_gsSheetData: (googleSheetsId, sheetName, sheetKey) => { dispatch({ type: rts.handleGet_gsSheetData, dispatch, googleSheetsId, sheetName, sheetKey }) },
    handleGet_gsSheetDatas: (googleSheetsId, sheetName, sheetKey) => { dispatch({ type: rts.handleGet_gsSheetDatas, dispatch, googleSheetsId, sheetName, sheetKey }) },
    handleGet_gsTabValues: (settings, sheetType, latestSeason) => { dispatch({ type: rts.handleGet_gsTabValues, dispatch, settings, sheetType, latestSeason }) },
    handleInit_sportsSidebar: (sportsDataMode, sports_current, access_teams, access_sports, access_schools) => { dispatch({ type: rts.handleInit_sportsSidebar, dispatch, sportsDataMode, sports_current, access_teams, access_sports, access_schools }) },
    // handleSave_sportsDataToDatabase: (allRosters) => { dispatch({ type: rts.handleSave_sportsDataToDatabase, dispatch, allRosters }) },
    // handleSave_glsToDatabase: (data) => { dispatch({ type: rts.handleSave_glsToDatabase, dispatch, data }) },
    // handleSave_teamSettings: (sheetType, data, currentMenuKey) => { dispatch({ type: rts.handleSave_teamSettings, dispatch, sheetType, data, currentMenuKey }) },
    handleSet_currentMenuKey: (currentMenuKey) => { dispatch({ type: rts.handleSet_currentMenuKey, dispatch, currentMenuKey }) },
    handleSet_formData: (formData) => { dispatch({ type: rts.handleSet_formData, dispatch, formData }) },
    handleSet_gsSheetData: (sheetName, results, sheetKey) => { dispatch({ type: rts.handleSet_gsSheetData, dispatch, sheetName, results, sheetKey }) },
    handleSet_gsSheetDatas: (sheetName, data) => { dispatch({ type: rts.handleSet_gsSheetDatas, dispatch, sheetName, sheetName, data }) },
    handleSet_gsTabValues: (sheetName, sheetType, results) => { dispatch({ type: rts.handleSet_gsTabValues, dispatch, sheetName, sheetType, results }) },
    handleShow_createNew: () => { dispatch({ type: rts.handleShow_createNew, dispatch }) },
    handleUpdate_gsDistrictAccess: (current_accessOrGls, globalItems, globalItem, sport) => { dispatch({ type: rts.handleUpdate_gsDistrictAccess, dispatch, current_accessOrGls, globalItems, globalItem, sport }) },
    ...responseHandlers(dispatch)
  }
}

export const sportsSidebarInitialState = (init_state) => {
  return { ...init_state }
};

const getInitState = (action, state) => {

  const { sportsDataMode, sports_current, access_teams, access_sports, access_schools } = action

  const {
    parent: {
      access: {
        access_schools_schools,
      },
      gls: {
        gls_scores,
        gls_teams,
      },
    },
    news,
    pathViews,
    schools_district,
    sportsKey,
    rosters,
    teams,
    tournaments,
  } = state

  let sportAccessType;

  switch (sportsDataMode) {
    case _sdm.sports.teamRosters:
      sportAccessType = sportAccessTypes.team
      break;

    case _sdm.district.glsScores:
      sportAccessType = sportAccessTypes.scoreLink
      break;

    case _sdm.district.districtSchools:
    case _sdm.district.accessSchools:
    case _sdm.district.contactsSchools:
      sportAccessType = sportAccessTypes.school
      break;

    case _sdm.district.accessSports:
      sportAccessType = sportAccessTypes.sport
      break;

    case _sdm.sports.accessTeams:
      sportAccessType = sportAccessTypes.team
      break;

    case _sdm.district.updateDistrictSeasonScores:
      sportAccessType = sportAccessTypes.none
      break;

    case _sdm.sports.tournamentResults:
      sportAccessType = sportAccessTypes.tournamentResults
      break;

    case _sdm.sports.news:
      sportAccessType = sportAccessTypes.news
      break;

    default:
    // nothing
  }

  const _isSport = pathViews && pathViews.sports ? true : false

  const sportsMode = {
    organization: pathViews && pathViews.organizations && !pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    district: pathViews && pathViews.districts && !pathViews.schools && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    match: pathViews && pathViews.matches ? true : false,
    school: pathViews && pathViews.schools ? true : false,
    sport: pathViews && pathViews.sports ? true : false,
    team: false,
  }

  const _initState = { ...state, sportsDataMode };

  console.log('sportsDataMode', sportsDataMode)

  switch (sportsDataMode) {

    case _sdm.district.glsScores:
      _initState.glsScores = gls_scores
      ammendInitState(_initState, sports_current, gls_scores, gls_scores, null, _accessOptions.team, 'Update Score Settings', _sportCollections_pks.gls_scores)
      break;

    case _sdm.sports.glsTeam:
      _initState.glsTeams = gls_teams
      ammendInitState(_initState, teams, gls_teams, gls_teams, null, _accessOptions.team, 'Update Team Settings!', _sportCollections_pks.gls_teams)
      break;

    case _sdm.sports.teamRosters:
      const { teams: teamRosters } = gls_teams ?? {}
      _initState.teamRosters = teamRosters
      ammendInitState(_initState, teams, rosters, rosters, null, null, 'Update Team Rosters', _sportCollections_pks.teamRosters)
      break;

    case _sdm.sports.tournamentResults:
      convertHelpers.createItemKeys(tournaments)
      _initState.tournamentResults = tournaments
      ammendInitState(_initState, tournaments, tournaments, tournaments, null, null, 'Update Tournament Results', _sportCollections_pks.tournaments)
      break;

    case _sdm.sports.news:
      convertHelpers.createItemKeys(news)
      _initState.news = news
      ammendInitState(_initState, news, news, news, null, null, 'Update News', _sportCollections_pks.news)
      break;

    case _sdm.district.updateDistrictSeasonScores:
      ammendInitState(_initState, sports_current, null, null, null, _accessOptions, 'Update Team Settings', _sportCollections_pks.gls_teams, null, true)
      break;

    case _sdm.district.contactsSchools:
      ammendInitState(_initState, schools_district, null, null, 'contactsSchools', _accessOptions, 'Update School Contact Settings', _sportCollections_pks.schoolContacts)
      break;

    case _sdm.district.districtSchools:
      ammendInitState(_initState, schools_district, null, null, 'contactsDistrict', _accessOptions, 'Update District Contact Settings', _sportCollections_pks.districtContacts)
      break;

    case _sdm.district.sportsData:
      const tps = {}
      const _menuItems = _isSport ? _sportCollections : _districtCollections
      _.forEach(_menuItems, function (k, v) {
        tps[k] = { name: k, _itemKey: k }
        switch (k) {
          case _sportCollections._matches_seasonal:
            tps[k].subCollection = 'matches'
            break;
          case _sportCollections._scores_seasonal:
            tps[k].subCollection = 'scores'
            break;
          default:
          // nothing
        }
      })
      ammendInitState(_initState, tps, null, null, null, _accessOptions, 'Export Data', _sportCollections_pks.gls_teams, true, true)
      break;

    default:
      let items = []

      switch (sportsDataMode) {

        case _sdm.district.glsDistrict:
          items = { selectSport: { name: 'District', _itemKey: 'selectDistrict' } }
          break;

        default:
          switch (sportAccessType) {

            case sportAccessTypes.school:
              ammendInitState(_initState, schools_district, access_schools, access_schools, 'accessSchools', _accessOptions.schools, 'Update School Access', _sportCollections_pks.sportsAccess_district)
              break;

            case sportAccessTypes.sport:
              if (sportsMode.district) {
                ammendInitState(_initState, sports_current, access_sports, access_sports, 'accessSports', _accessOptions.sport, 'Update Sport Access', _sportCollections_pks.sportsAccess_sports)
              } else if (sportsMode.school) {
                const _sportAccess = access_schools_schools ? access_schools_schools[pathViews.schools] : {}
                ammendInitState(_initState, sports_current, _sportAccess, _sportAccess, 'accessSports', _accessOptions.sport, 'Update Sport Access', _sportCollections_pks.sportsAccess_schools)
              }
              break;

            case sportAccessTypes.team:
              ammendInitState(_initState, teams, access_teams, access_teams, 'teamAccess', _accessOptions.team, 'Update Team Access', _sportCollections_pks.sportsAccess_teams)
              break;

            default:
            // nothing
          }
      }
  }

  return _initState
}

const ammendInitState = (uds, menuItems, menuObjects, current_accessOrGls, propName, accessOptions, saveCaption, collectionName, isContent, showItemKey) => {
  uds.current_accessOrGls = current_accessOrGls
  uds.accessOptions = accessOptions
  uds.collectionName = collectionName
  uds.isContent = isContent
  uds.menuItems = menuItems
  uds.menuObjects = menuObjects
  uds.propName = propName
  uds.saveCaption = saveCaption
  uds.showItemKey = showItemKey
}

const getSportsFormProps = (state) => {

  const { sportsDataMode, sportAccessType, propName } = state

  let form_props;

  switch (sportsDataMode) {
    case _sdm.district.glsScores:
      form_props = _sportsFormProps.glsScores
      break;

    case _sdm.sports.glsTeam:
      form_props = _sportsFormProps.glsTeam
      break;

    case _sdm.sports.tournamentResults:
      form_props = _sportsFormProps.tournament
      break;

    case _sdm.sports.sportsSettings:
      form_props = _sportsFormProps.sportsSettings
      break;

    case _sdm.sports.news:
      form_props = _sportsFormProps.news
      break;

    case _sdm.district.updateDistrictSeasonScores:
      form_props = _sportsFormProps.scoreLink
      break;

    default:
      switch (sportAccessType) {
        case sportAccessTypes.accessLink:
          form_props = _sportsFormProps.glsDistrict
          break;
        case sportAccessTypes.scoreLink:
          form_props = _sportsFormProps.glsScores
          break;

        default:
          form_props = propName ? _sportsFormProps[propName] : _sportsFormProps.access
      }
  }

  return form_props

}

/**
 * 
 * @param {string} currentMenuKey 
 * @param {object} state 
 * @returns the formData object
 */
const getFormData = (currentMenuKey, state) => {

  const {
    formProps,
    propName,
    current_accessOrGls,
    sportsDataMode,
  } = state

  let _formData = {};
  let _currentData = {}
  let _ammendData = true

  if (current_accessOrGls && currentMenuKey && current_accessOrGls[currentMenuKey]) {
    _currentData = current_accessOrGls[currentMenuKey]
  }

  switch (sportsDataMode) {
    case _sdm.sports.accessTeams:
    case _sdm.district.accessSchools:
    case _sdm.district.accessSports:
      _ammendData = false
      break;
    default:
    // nothing
  }

  if (_ammendData) {
    ammendFormData(_formData, formProps, _currentData, propName)
  } else {
    _formData = _currentData
  }

  return _formData

}

const ammendFormData = (formData, form_props, data, propName) => {
  Object.keys(form_props).forEach(fp => {
    switch (fp) {
      case [propName]:
        formData[fp] = data && data[fp] ? [...data[fp]] : []
        break;
      default:
        formData[fp] = data && data[fp] ? data[fp] : ''
    }
  })
}


const getGsSheetData = (fn_cls, action, callback) => {

  const { googleSheetsId, sheetName, sheetKey } = action

  const cb = (formData, results) => {
    callback(_.camelCase(sheetName), results, sheetKey)
  }
  const formData = {
    sheetName: sheetName,
    googleSheetsId: googleSheetsId
  }
  fn_cls.getGoogleSheetRange(formData, cb, null, true)
}

const getGsSheetsData = (fn_cls, action, callback) => {

  const { googleSheetsId, sheetName, sheetKey } = action

  const cb = (data) => {
    callback(_.camelCase(sheetName), data?.data)
  }
  const formData = {
    sheetName: sheetName,
    googleSheetsId: googleSheetsId
  }
  fn_cls.getGoogleSheetsRanges(formData, cb, null, true)
}

const getGsTabValues = (fn_cls, settings, sheetType, sportsDataMode, latestSeason, callback) => {

  const { googleSheetsId, rosterSheet, staffSheet } = settings

  let sheetName;

  switch (sheetType) {
    case _sportsFormProps.glsTeam.rosterSheet:
      sheetName = rosterSheet
      break;
    case _sportsFormProps.glsTeam.staffSheet:
      sheetName = staffSheet
      break;
    default:
    // nothing
  }

  const cb = (fd, results) => {
    if (results) {
      switch (sportsDataMode) {
        case _sdm.sports.glsTeam:
          callback(_.camelCase(sheetName), sheetType, results)
          break;
        default:
        // nothing
      }
    }
  }
  const formData = {
    sheetName: sheetName,
    googleSheetsId: googleSheetsId
  }
  fn_cls.getGoogleSheetRange(formData, cb, null, true, null, latestSeason)
}

const createGsTeamSheetsWithProtections = async (fn_cls, action) => {
  const { access_teams, teams } = action
  if (access_teams && teams) {
    const _sheetTeams = {}
    _.forEach(access_teams, (value, key) => {
      // if (key === 'VlN5Ya0oY045OMFBxfTA') {
      const { name: email } = value[0]
      const _team = teams[key]
      const { name } = _team ?? {}
      _sheetTeams[key] = {
        name,
        email
      }
      // }
    })
    const _teams = _.sortBy(_sheetTeams, 'name')
    await fn_cls.createTeamSheets('1p42B-oO8Ih9_JJ8SBpy2_uHWo6JrlCVUm9eZOUruBYk', _teams, true)

  }
}

const updateGsDistrictAccess = async (fn_cls, action, state) => {
  const { sportsModeKey } = state
  const { current_accessOrGls, globalItems, globalItem, sport } = action
  const _items = []
  Object.keys(current_accessOrGls).forEach(sak => {
    const sportAccess = current_accessOrGls[sak]
    if (sportAccess) {
      sportAccess.forEach(sa => {
        const { name, accessLevel } = sa
        if (globalItems[sak]) {
          const _item = {
            name,
            [globalItem]: globalItems[sak].name,
            accessLevel
          }
          if (sport) {
            _item.sport = _.startCase(sportsModeKey)
          }
          _items.push(_item)
        }
      })
    }
  })
  const headers = sport ? ['id', 'name', globalItem, 'sport', 'accessLevel'] : ['id', 'name', globalItem, 'accessLevel']
  const gsv = getGoogleSheetDataValues(_items, headers, 'School Access')
  const { values } = gsv
  await fn_cls.updateGoogleSheetValues('1wM1S8OuHK7omYIGsu5snNLEVt4zR72zOYkNpoEH4Wd4', _.startCase(globalItem) + ' Access', values)
}